const NS = 'FeaturedContentTileContainerBlock';
const CLS = 'featuredContentTileContainerBlock';
const BLK = '.' + CLS + '-';

import { mediaQuery } from '../../../../global/js/ara/mediaQuery';

export class FeaturedContentTileContainerBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$side = this.$element.find(`.${CLS}-side`);
		this.$mainImg = this.$element.find(`.${CLS}-main .featuredContentTileItemBlock-imgWrap`);
		this.mediaQuery = mediaQuery;

		$(window).resize(_.debounce(() => {
			this.setMainImageHeight();
		}, 50));

		this.setMainImageHeight();
	}

	setMainImageHeight() {
		if(!this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.LG)) {
			let firstItemHeight = this.$side.find(`.${CLS}-item:first-child`).outerHeight(true);
			let lastImageHeight = this.$side.find(`.${CLS}-item:last-child .featuredContentTileItemBlock-img`).outerHeight();
			let newHeight = firstItemHeight + lastImageHeight;
			this.$mainImg.css({
				height: `${newHeight}px`,
				paddingTop: 'unset'
			});
		}
		else {
			this.$mainImg.css({
				height: '',
				paddingTop: ''
			});
		}
	}
}
